import { render, staticRenderFns } from "./CourseContent.vue?vue&type=template&id=4595923c&scoped=true"
import script from "./CourseContent.vue?vue&type=script&lang=js"
export * from "./CourseContent.vue?vue&type=script&lang=js"
import style0 from "./CourseContent.vue?vue&type=style&index=0&id=4595923c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4595923c",
  null
  
)

export default component.exports